import { useEffect } from "react"
import { useAppDispatch } from "./redux/hooks"
import { getSupportAssets, getSupportChains } from "services/thunkServices"
import { checkMobile } from "utils"
import { useNavigate } from "react-router-dom"

const useInitData = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getSupportChains())
    dispatch(getSupportAssets())
  }, [dispatch])
    
  useEffect(() => {
    if(checkMobile()) {
      navigate("/mobile")
    }
  }, [navigate])
}

export default useInitData